import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { Router, RouterModule } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-bottom-navigator',
  imports: [
    MatIcon, 
    RouterModule,
    TranslatePipe
  ],
  templateUrl: './bottom-navigator.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './bottom-navigator.component.scss'
})
export class BottomNavigatorComponent {

  routeOrder = ['(home:historical)', '(home:greetings)', '(home:profile)'];
  previousIndex = 0;

  constructor(private router: Router) {}

  onItemClicked(event: any){
    if ('vibrate' in navigator) {
      navigator.vibrate(100);
    }
  }

}
